export default function DiscordSection() {
  return (
    <section id="discord" className="relative py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="relative bg-gradient-to-br from-[#5865F2]/20 to-[#7289DA]/20 backdrop-blur-sm rounded-3xl p-12 md:p-16 border border-[#5865F2]/30 overflow-hidden">
          {/* Background Discord Logo */}
          <div className="absolute right-0 top-1/2 -translate-y-1/2 opacity-5">
            <i className="ri-discord-fill text-[400px] text-white"></i>
          </div>

          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Side */}
            <div>
              <h2 className="text-5xl md:text-6xl font-black text-white mb-6">
                Topluluğumuza Katıl
              </h2>
              <p className="text-xl text-gray-300 mb-4 leading-relaxed">
                Binlerce oyuncuyla bağlantı kur, destek al, etkinliklere katıl ve en son haberlerden haberdar ol.
              </p>
              <p className="text-lg text-gray-400 mb-8 leading-relaxed">
                Discord sunucumuz FurukoNetwork topluluğunun kalbidir. Yapılarını paylaş, yeni arkadaşlar edin ve harika bir şeyin parçası ol!
              </p>

              <div className="flex flex-wrap gap-4 mb-8">
                <div className="flex items-center gap-3 bg-white/5 px-6 py-3 rounded-full border border-white/10">
                  <i className="ri-user-fill text-2xl text-cyan-400"></i>
                  <div>
                    <p className="text-2xl font-bold text-white">5,000+</p>
                    <p className="text-sm text-gray-400">Üye</p>
                  </div>
                </div>
                <div className="flex items-center gap-3 bg-white/5 px-6 py-3 rounded-full border border-white/10">
                  <i className="ri-chat-3-fill text-2xl text-lime-400"></i>
                  <div>
                    <p className="text-2xl font-bold text-white">7/24</p>
                    <p className="text-sm text-gray-400">Aktif Sohbet</p>
                  </div>
                </div>
              </div>

              <a
                href="https://discord.gg/FurukoNetwork"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 px-8 py-4 bg-[#5865F2] hover:bg-[#4752C4] text-white rounded-full font-bold text-lg transition-all hover:scale-105 hover:shadow-2xl hover:shadow-[#5865F2]/50 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-discord-fill text-2xl"></i>
                Discord Sunucusuna Katıl
              </a>
            </div>

            {/* Right Side - Discord Preview */}
            <div className="relative">
              <div className="bg-[#36393f] rounded-2xl p-6 shadow-2xl border border-white/10">
                <div className="flex items-center gap-3 mb-6 pb-4 border-b border-white/10">
                  <img
                    src="https://static.readdy.ai/image/c4da685b094ca03001fa4ce318bf4660/f59786c2d124de0541605a3b17561e77.png"
                    alt="FurukoNetwork"
                    className="w-12 h-12 rounded-full"
                  />
                  <div>
                    <h3 className="text-white font-bold text-lg">FurukoNetwork</h3>
                    <div className="flex items-center gap-2">
                      <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                      <span className="text-gray-400 text-sm">2,847 Çevrimiçi</span>
                    </div>
                  </div>
                </div>

                <div className="space-y-3">
                  <div className="flex items-center gap-3 text-gray-300 hover:bg-white/5 p-2 rounded cursor-pointer">
                    <i className="ri-hashtag text-xl"></i>
                    <span>duyurular</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-300 hover:bg-white/5 p-2 rounded cursor-pointer">
                    <i className="ri-hashtag text-xl"></i>
                    <span>genel-sohbet</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-300 hover:bg-white/5 p-2 rounded cursor-pointer">
                    <i className="ri-hashtag text-xl"></i>
                    <span>destek</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-300 hover:bg-white/5 p-2 rounded cursor-pointer">
                    <i className="ri-hashtag text-xl"></i>
                    <span>etkinlikler</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-300 hover:bg-white/5 p-2 rounded cursor-pointer">
                    <i className="ri-volume-up-fill text-xl"></i>
                    <span>Ses Kanalları</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
